<template>
  <div class="icon-container" :style="containerStyle" ref="icon">
    <template v-if="!isHover">
      <cxIcon class="icon" v-if="icon.iconType === 'icon' && icon.showIcon !== false"
        :options="iconOptions"
        :iconStyle="iconStyle"></cxIcon>
      <img class="icon" v-else-if="icon.iconType === 'img' && icon.iconSrc && icon.showIcon !== false"
          :src="icon.iconSrc"
          :style="iconStyle"/>
    </template>
    <template v-else-if="hoverIcon && isHover">
      <cxIcon class="icon" v-if="hoverIcon.iconType === 'icon' && hoverIcon.showIcon !== false"
        :options="hoverIconOptions"
        :iconStyle="hoverIconStyle"></cxIcon>
      <img class="icon" v-else-if="hoverIcon.iconType === 'img' && hoverIcon.iconSrc && hoverIcon.showIcon !== false"
          :src="hoverIcon.iconSrc"
          :style="hoverIconStyle"/>
    </template>
    
  </div>
</template>
<script>
import { remCheck } from 'utils';
export default {
  props: {
    icon: {
      type: Object,
      default: () => {}
    },
    hoverIcon: {
      type: Object,
      default: null
    },
    direction: {
      type: String,
      default: 'normal'
    }
  },
  computed: {
    containerStyle() {
      return this.direction === 'reverse' ? {
        transform: 'rotate(180deg)'
      }: {}
    },
    iconOptions() {
      return {
        iconSrc: this.icon.iconSrc,
        iconWidth: this.icon.iconWidth,
        iconMargin: this.icon.iconMargin,
        iconPosition: this.icon.iconPosition
      }
    },
    hoverIconOptions() {
      return {
        iconSrc: this.hoverIcon.iconSrc,
        iconWidth: this.hoverIcon.iconWidth,
        iconMargin: this.hoverIcon.iconMargin,
        iconPosition: this.hoverIcon.iconPosition
      }
    },
    iconStyle() {
      const data = this.icon || {}
      return {
        "display": "inline-block",
        "vertical-align": "middle",
        '--color': this.$parseColor(data.iconColor),
        fontSize: remCheck(data.iconWidth),
        width: remCheck(data.iconWidth),
        height: remCheck(data.iconWidth),
        margin: data.iconPosition === "left"
            ? (this.direction === 'reverse' ? `0 0 0 ${remCheck(data.iconMargin)}` : `0 ${remCheck(data.iconMargin)} 0 0`)
            : (this.direction === 'reverse' ? `0 ${remCheck(data.iconMargin)} 0 0` : `0 0 0 ${remCheck(data.iconMargin)}`)
      }
    },
    hoverIconStyle() {
      const data = this.hoverIcon || {}
      return {
        "display": "inline-block",
        "vertical-align": "middle",
        '--color': this.$parseColor(data.iconColor),
        fontSize: remCheck(data.iconWidth),
        width: remCheck(data.iconWidth),
        height: remCheck(data.iconWidth),
        margin: data.iconPosition === "left"
            ? (this.direction === 'reverse' ? `0 0 0 ${remCheck(data.iconMargin)}` : `0 ${remCheck(data.iconMargin)} 0 0`)
            : (this.direction === 'reverse' ? `0 ${remCheck(data.iconMargin)} 0 0` : `0 0 0 ${remCheck(data.iconMargin)}`)
      }
    }
  },
  data() {
    return {
      isHover: false
    }
  },
  mounted() {
    if (this.hoverIcon) {
      this.$refs.icon.addEventListener("mouseenter", () => {
        this.isHover = true
      })
      this.$refs.icon.addEventListener("mouseleave", () => {
        this.isHover = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.icon-container {
  display: inline-block;
  display: flex;
  align-items: center;
}
</style>